import React, { useMemo } from "react";
import { Form, Button } from "react-bootstrap";
import { ReactComponent as OutlinePlus } from "assets/svg/outline-plus.svg";
import { ReactComponent as OutlinePlus16 } from "assets/svg/outline-plus-16.svg";
import styles from "./styles.module.scss";
import { AmplitudePageName, track } from "utils/amplitude";
// import messages from "messages";

export function makeImageFromUri(uri) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      resolve(img);
    };
    img.onerror = () => {
      reject(`failed to make image from: ${uri}`);
    };
    img.src = uri;
  });
}

export function imageAsCanvas(img, width, height) {
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  canvas.width = width || img.width;
  canvas.height = height || img.height;
  ctx?.drawImage(img, 0, 0, canvas.width, canvas.height);
  return canvas;
}

function resizeImageAsCanvas(img, maxWidth, maxHeight) {
  const aspectImg = img.width / img.height;
  const aspectDest = maxWidth / maxHeight;
  if (aspectImg > aspectDest) {
    return imageAsCanvas(img, img.width * (maxHeight / img.height), maxHeight);
  } else {
    return imageAsCanvas(img, maxWidth, img.height * (maxWidth / img.width));
  }
}

export function resizeImageAsDataUri(img, maxWidth, maxHeight) {
  const canvas = resizeImageAsCanvas(img, maxWidth, maxHeight);
  return canvas.toDataURL("image/jpeg", 0.85);
}

export function resizeImageAsBlob(img, maxWidth, maxHeight) {
  return new Promise((resolve, reject) => {
    const canvas = resizeImageAsCanvas(img, maxWidth, maxHeight);
    canvas.toBlob(
      (blob) => {
        resolve(blob);
      },
      "image/jpeg",
      0.85,
    );
  });
}

export function imageDataUriToBlob(dataUri) {
  return new Promise(async (resolve, reject) => {
    const canvas = imageAsCanvas(await makeImageFromUri(dataUri), null, null);
    canvas.toBlob((blob) => resolve(blob), "image/jpeg", 0.85);
  });
}

type Props = {
  imagePreviewUrl?: string | null;
  onImageChanged: (arg: string | ArrayBuffer | null | undefined) => void;
  amplitudePageName: AmplitudePageName;
};

export const ImageUpload = ({
  imagePreviewUrl,
  onImageChanged,
  amplitudePageName,
}: Props) => {
  const imagePreview = useMemo(
    () =>
      !imagePreviewUrl ? undefined : (
        <img
          src={imagePreviewUrl}
          onError={(e) => {
            (e.target as HTMLImageElement).onerror = null;
            (e.target as HTMLImageElement).src =
              "/img/placeholder/add-photo.svg";
          }}
          onClick={() => {
            document.getElementById("inputGroupFile01")?.click();
          }}
          alt="orchid-profile-img"
          className={styles["profile-img"]}
          style={{ cursor: "pointer" }}
        />
      ),
    [imagePreviewUrl],
  );

  const handleImageChange = (e) => {
    e.preventDefault();
    let reader = new FileReader();
    let file = e.target.files[0];
    reader.onloadend = (e) => {
      onImageChanged(e.target?.result);
    };
    if (file) reader.readAsDataURL(file);
  };

  return (
    <>
      <Form.Group className={styles["image-preview"]}>
        {imagePreview ? (
          imagePreview
        ) : (
          <Form.Label htmlFor="inputGroupFile01">
            <label className={styles["image-preview--empty"]}>
              <OutlinePlus />
              Add photo
            </label>
          </Form.Label>
        )}
        <Form.Control
          type="file"
          id="inputGroupFile01"
          onChange={(e) => handleImageChange(e)}
          style={{ display: "none" }}
        />
      </Form.Group>
      {/* {!imagePreview ? ( */}
      <Button
        className={styles["image-preview--button-alike"]}
        onClick={() => {
          track(amplitudePageName, "add-photo-button", "click");
          document.getElementById("inputGroupFile02")?.click();
        }}
      >
        <Form.Control
          type="file"
          id="inputGroupFile02"
          onChange={(e) => handleImageChange(e)}
          style={{ display: "none" }}
        />
        <span className={"d-flex align-items-center"}>
          <OutlinePlus16 className={"mr-2"} />
          Add photo
        </span>
      </Button>
      {/* ) : (
        <Button
          variant="outline-primary"
          onClick={() => onImageChanged(undefined)}
        >
          {messages.deletePhoto}
        </Button>
      )} */}
    </>
  );
};
